export default "__VITE_ASSET__C0Un3msB__"